import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getTickets,
    updateTicket
}

function getTickets(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/tickets`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateTicket(ticketId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/tickets/${ticketId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}